import _ from 'lodash'
import { cleanPrinters } from './physical-printers-references'
import { cleanDisplays } from './displays/clean-displays'
import { cleanDepartment } from './department/clean-department'
import { cleanLayout } from './layout/clean-layout'
import { cleanRequirements } from './requirements/clean-requirements'
import { cleanOffers } from 'shared-js/references/menu/offers/clean-offers'
import { cleanCategorySubheader } from './department/clean-category-subheader'
import { cleanFeaturedItems } from './department/clean-featured-items'

/**
 * Removes the orphan references in the `menuBlob`
 * @param {Object} menuBlob - The Menu Blob to clean up
 * @param {Object} settingsBlob - The Settings Blob
 * @param {boolean, Number} forPublish - For cleanDepartment to withhold inactive pricing from blob and to remove
 *                               inclusion references for modifiers that are not enabled in the department.
 * Calls to cleanMenu from the UI (i.e. not for publish) at were passing forPublish = true when at the location level.
 * That's been changed to pass a 1 instead so modifier cleaning can know if it's really for publish.
 */
export function cleanMenu (menuBlob, settingsBlob, forPublish = false) {
  cleanOnlineCategories(menuBlob)
  cleanFeaturedItems(menuBlob)
  cleanDepartments(menuBlob, forPublish)
  cleanPrinters(menuBlob, settingsBlob)
  cleanDisplays(menuBlob, settingsBlob)
  cleanLayout(menuBlob, settingsBlob)
  cleanRequirements(menuBlob)
  cleanOffers(menuBlob)
}

function cleanOnlineCategories (menuBlob) {
  cleanCategorySubheader(_.get(menuBlob, 'onlineCategories', []))
}

function cleanDepartments (menuBlob, forPublish) {
  for (let department of _.get(menuBlob, 'departments', [])) {
    cleanDepartment(department, menuBlob, forPublish)
  }
}
